import { CARD_LIST } from "./card-list.query";
import { ICardListResponse } from "./card-list.interface";
import { paymentActions } from "../../state/payment";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";

export const useCardList = () => {
  const dispatch = useDispatch();
  const [getListCards, { loading, data }] = useLazyQuery<{ getListCards: ICardListResponse }>(CARD_LIST, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    getListCards();
  }, []);

  useEffect(() => {
    if (data) {
      const isCardAdded = data?.getListCards?.cards?.length ?true : false;

      dispatch(paymentActions.setCardAddedStatus(isCardAdded));
    }
  }, [data]);

  return {
    loading: loading,
    cardList: data?.getListCards,
    getListCards,
  };
};
